export const sortByPublishDate = (a, b) => {
  if (a.publishDate > b.publishDate) {
    return -1;
  } else {
    return 1;
  }
};
